<template>
  <div class="app-layout over-hidden-x">
    <el-card class="box-card" shadow="never" v-loading="queryLoading">
      <el-form
        size="small"
        :model="formQuery"
        label-width="80px"
      >
        <el-row type="flex" class="flex-justify-left">
          <el-col :span="6">
            <el-form-item label="时间范围">
              <el-date-picker
                v-model="formQuery.range"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                unlink-panels
                :clearable="false"
                @change="queryPageInfo"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="margin-left-20">
            <el-form-item label="所属页面" prop="pagePath" required>
              <el-select
                v-model="formQuery.pagePath"
                filterable
                placeholder="请选择页面"
                @change="queryEvent"
                style="width: 100%"
              >
                <el-option v-for="item in pageInfos" :key="item.pagePath"
                  :value="`${item.pagePath}(${item.pageName})`">
                  <template v-if="item.pagePath.length < 60">
                    {{ item.pagePath }}
                    <template v-if="item.pageName">({{ item.pageName }})</template>
                  </template>
                  <el-tooltip v-else effect="light" :content="`${item.pagePath}(${item.pageName})`"
                    placement="right">
                    <p>
                      {{ item.pagePath.slice(0, 60) }}...
                      <template v-if="item.pageName">({{ item.pageName }})</template>
                    </p>
                  </el-tooltip>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col class="flex-1">
            <el-form-item>
              <div class="align-right">
                <el-button type="success" @click="handleSave">保存链路</el-button>
                <el-button @click="handleSave(true)">保存并查看分析</el-button>
              </div>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-form-item v-if="false">
          <el-button @click="handleAddNodes">获取节点参数</el-button>
        </el-form-item>
      </el-form>

      <el-form
        size="small"
        label-width="80px"
      >
        <el-form-item label="事件集合">
          <div class="event-list" ref="eventList">
             <!-- @click="handleAddEvent(item, index)" -->
             <el-collapse
              v-model="activeName"
              accordion
              v-if="Object.entries(cacheEventsComputer).length"
            >
              <el-collapse-item
                :title="name"
                :name="name"
                :id="`collapse_${name}`"
                v-for="([name, list], index) in Object.entries(cacheEventsComputer)"
                :key="index"
              >
                <div class="events">
                  <div
                    :class="`event margin-bottom-5 ${
                      nodesGroupMap[item.eventCode] !== undefined ? 'success' : 'info'
                    }`"
                    v-for="(item, itemiIndex) in list"
                    :key="itemiIndex"
                    :draggable="edgeAdding ? false : true"
                    :id="item.id"
                    @dragstart="handleDragstart(item)"
                    @dragend.prevent="handleDragend($event, item)"
                    :style="{ cursor: edgeAdding ? 'not-allowed' : 'move' }"
                  >
                    <p class="event-title"><strong>{{ item.eventName }}</strong></p>
                    <p>{{ item.eventCode }}</p>
                    <p class="event-icon" v-if="nodesGroupMap[item.eventCode] !== undefined">
                      {{ nodesGroupMap[item.eventCode] + 1 }}
                    </p>
                </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <div class="align-left" v-else>
              <el-link
                :underline="false"
                size="mini"
                type="info"
                class="align-left color-gray"
              >请先选择所属页面</el-link>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <div class="container"
        ref="container"
        :style="{
          height: `${containerHeight}px`,
        }"
      >

        <div class="container-title">

            <div
              class="item-hover"
              @click="handleAddGroup(groups.length)"
              :style="{
                opacity: 1,
                cursor: 'pointer',
                left: `${(groups.length * groupWidth)}px`,
                height: `${containerHeight}px`,
              }"
            >
              <el-tooltip
                effect="dark"
                content="添加分组"
                placement="top"
              >
                <div class="item-hover-container">
                  <i class="el-icon-circle-plus-outline item-hover-icon"></i>
                  <span
                    class="item-hover-bar"
                    :style="{
                      height: `${containerHeight}px`,
                    }"
                  ></span>
                </div>
              </el-tooltip>
            </div>

          <div
            class="container-title-item"
            v-for="(item) in groups"
            :key="item.id"
            :style="{ width: `${groupWidth}px` }"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>

        <div
          id="container"
          :style="{ width: `${containerWidth}px`, height: `${containerHeight}px`, }"
        ></div>
      </div>
      <el-form
        size="small"
        :model="formQuery"
        ref="queryFrom"
        label-width="80px"
        class="margin-top-20"
      >
        <el-row :gutter="20" type="flex" class="flex-justify-left">
          <el-col :span="6">
            <el-form-item
              label="链路名称"
              prop="traceName"
              :rules="[{ required: true, message: '请输入链路名称'}]"
            >
              <el-input
                clearable
                v-model="formQuery.traceName"
                placeholder="请输入链路名称"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="链路描述" prop="traceDesc">
              <el-input
                clearable
                v-model="formQuery.traceDesc"
                placeholder="请输入链路描述"
                maxlength="40"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="align-center">
        <el-button size="mini" type="success" @click="handleSave(false)">保存链路</el-button>
        <el-button size="mini" @click="handleSave(true)">保存并查看分析</el-button>
      </div>
    </el-card>

  </div>
  </template>
<script>
/* eslint-disable no-param-reassign */
import G6 from '@antv/g6';
import Moment from 'moment';
import { mapGetters } from 'vuex';
import {
  queryEvent as queryEventApi,
  saveEventTrace,
  modifyEventTrace,
} from '@/api/event';
import {
  queryPageInfo,
} from '@/api/page-analyze';
import { cloneDeep } from 'lodash';
import { Message } from 'element-ui';
import EventNode from './node/event';
// import AddEvent from './components/add-event.vue';
// import clickAddEdge from './behavior/click-add-edge';

export default {
  // components: {
  //   AddEvent,
  // },

  computed: {
    ...mapGetters('app', ['env', 'source']),
    cacheEventsComputer() {
      const {
        cacheEvents,
      } = this;

      const res = {};
      cacheEvents.forEach((item) => {
        const name = `${item.pagePath}(${item.pageName})`;
        if (!res[name]) {
          res[name] = [];
        }
        res[name].push(item);
      });
      return res;
    },
  },

  data() {
    return {
      activeName: 0,
      queryLoading: false,
      formQuery: {
        range: [],
        pageNum: 1,
        pageSize: 999,
        pagePath: '',
        id: '',
        traceName: '',
        traceDesc: '',
        traceType: '1', // 链路类型，1-单入口链路
      },
      pageInfos: [],
      graph: null,
      value: '',

      isProcessing: false,
      eventDialogVisible: false,
      edgeAdding: false,
      containerMinWidth: 1200, // 容器最小的宽度
      containerWidth: 1200, // 容器的宽度
      containerHeight: 500, // 容器的高度
      groupWidth: 240, // 一组的宽度
      groupHeight: 80, // 一个事件高度
      groupLineWidth: 5, // 分割线的宽度
      eventNodeWidth: 120, // 事件节点的宽度

      insertEvent: null, // 待插入的事件
      // insertIndex: null, // 待插入的事件的序号

      dargEvent: null,

      lineColor: ['rgb(95, 204, 144)', 'rgb(103, 193, 186)', 'rgb(104, 177, 229)', 'rgb(86, 146, 238)', 'rgb(248, 204, 198)', 'rgb(64, 158, 255)', 'rgb(103, 194, 58)'], // 创建的分界线的颜色

      // 分组
      groups: [],

      // 所有的事件列表
      cacheEvents: [],

      // 当前事件
      events: [],

      // 节点
      nodes: [],

      nodesGroupMap: {},
    };
  },
  watch: {
    source: {
      handler() {
        this.clear();
        this.queryPageInfo();
      },
    },
    env: {
      handler() {
        this.clear();
        this.queryPageInfo();
      },
    },
  },
  methods: {
    clear() {
      this.formQuery.pagePath = '';
      this.nodes.splice(0);
      this.cacheEvents.splice(0);
      this.events.splice(0);
      this.nodesGroupMap = {};
      if (this.graph) {
        this.graph.destroy();
        this.graph = null;
      }
      this.init();
    },
    async handleSave(isToAnalysis) {
      try {
        await this.$refs.queryFrom.validate();

        const {
          nodes,
          source,
        } = this;
        const traceConfigs = [];
        const valieList = {};

        // 判断多少分组
        nodes.forEach((node, index) => {
          if (node.type === 'event') {
            if (!valieList[node.group]) {
              valieList[node.group] = 1;
            } else {
              valieList[node.group]++;
            }
            traceConfigs.push({
              ...node.item,
              group: node.group,
              groupSeq: node.group,
              seq: index,
              source,
            });
          }
        });
        if (Object.entries(valieList).some(([name, value]) => {
          if (!value) {
            this.$message.warning(`第${++name}组的事件不能为空`);
            return true;
          }
          return false;
        })) {
          // 存在分组没有指定事件
          return;
        }

        this.queryLoading = true;

        const {
          id, traceName, traceDesc, traceType,
        } = this.formQuery;

        const params = {
          traceName,
          traceDesc,
          traceType,
          traceConfigs,
        };
        let postMethod = saveEventTrace;

        if (id) {
          params.id = id;
          postMethod = modifyEventTrace;
        }
        const {
          data,
        } = await postMethod(params);

        if (data) {
          this.formQuery.id = data.id;
          this.$message.success('保存成功！');
        } else {
          this.$message.success('更新成功！');
        }

        if (isToAnalysis) {
          this.$router.push({
            name: 'LinkaAnalysis',
            query: {
              id: id || data.id,
              traceName,
              traceDesc,
            },
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryPageInfo() {
      this.queryLoading = true;
      try {
        const { range } = this.formQuery;
        const data = {
          analyzeTimeTo: Moment(range[1]).format('YYYY-MM-DD'),
          analyzeTimeFrom: Moment(range[0]).format('YYYY-MM-DD'),
        };
        const {
          data: { pageInfos },
        } = await queryPageInfo(data);

        // if (!this.formQuery.pagePath) {
        //   this.formQuery.pagePath = pageInfos[0]?.pagePath || '';
        // }
        this.pageInfos.splice(0, this.pageInfos.length, ...pageInfos);
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryEvent() {
      try {
        this.queryLoading = true;

        // eslint-disable-next-line object-curly-newline
        const { pagePath, pageNum, pageSize } = this.formQuery;

        const params = {
          pageNum,
          pageSize,
          pagePath: pagePath.replace(/(\().+(\))/g, ''),
        };

        const {
          data: { list },
        } = await queryEventApi(params);

        list.map((item) => {
          item.id = String(item.id);

          if (!(this.cacheEvents.find((event) => event.eventCode === item.eventCode))) {
            this.cacheEvents.push(item);
          }
          return item;
        });

        // this.cacheEvents.push(..list);
        this.events.splice(0, this.events.length, ...list);
        if (!list.length) {
          this.$message.warning('当前所属页面下没有关联事件');
        }

        this.activeName = pagePath;
        this.$nextTick(() => {
          const scrollElem = this.$refs.eventList; // 对应ref的命名
          const scrollToElem = document.getElementById(`collapse_${pagePath}`); // 对应ref的命名

          scrollElem.scrollTo({ top: scrollToElem.offsetTop, behavior: 'smooth' });
        });
      } finally {
        this.queryLoading = false;
      }
    },
    handleAddNodes() {
      console.log(this.graph.save().nodes.map((item) => item.id));
    },
    /**
       * 创建节点按照分组
       */
    createNodeGroups(nodes) {
      const result = {};
      if (nodes && nodes.length) {
        nodes.forEach((node) => {
          // eslint-disable-next-line no-cond-assign
          if (result[node.group] || (result[node.group] = [])) {
            result[node.group].push(node);
          }
        });
      }
      return result;
    },

    /**
       * 计算可以插入的位置
       */
    getInsertLastNode(lastNode, groups = []) {
      if (!lastNode || !groups) {
        return null;
      }

      if (!groups.length) {
        return null;
      }

      // 计算可以插入的位置
      groups.sort((a, b) => a.y - b.y);

      const groupYs = groups.map((group) => group.y);

      // 最小y大于120，表示首个位置依然可以插入
      if (Math.min(...groupYs) > 120) {
        return null;
      }

      // 判断每个数字之间是否是60的差距，如果不是，返回坐标
      let start = 0;
      let next = 1;
      let index = null;

      // 因为不是按照顺序排列，所以有可能存在插入位置不准确的问题，所以需要对数据进行
      while (start < groupYs.length && groupYs[start] && groupYs[next]) {
        if (groupYs[next] - groupYs[start] !== 60) {
          index = start;
          break;
        } else {
          start++;
          next++;
        }
      }
      return index !== null ? groups[index] : ((groups[groups.length - 1]) || lastNode);
    },

    /**
       * 插入节点
       */

    /**
       * 确认添加节点 debug
       */
    handleAddEventConfirm(groupId) {
      if (this.isProcessing) {
        return;
      }

      this.isProcessing = true;

      const data = cloneDeep(this.graph.save());

      // debugger;
      console.log('==== 插入数据前 ======');
      console.log(data);
      console.log('');

      const nodeGroups = this.createNodeGroups(data.nodes);

      const currentGroups = nodeGroups[groupId];

      const lastNode = this.getInsertLastNode(
        currentGroups ? currentGroups[currentGroups.length - 1] : [],
        currentGroups,
      );

      const insertNode = this.createNode({
        ...this.insertEvent,
        group: groupId,
      }, lastNode);

      // this.events.splice(this.insertIndex, 1);

      let findIndex = 0;
      const filter = data.nodes.filter((item, index) => {
        if (item.id === insertNode.id) {
          findIndex = index;
          return true;
        }
        return false;
      });

      if (filter.length) {
        if (filter[0].group === groupId) {
          this.$message.warning('该组别已有相同事件，请勿重复添加');
          setTimeout(() => {
            this.isProcessing = false;
          }, 100);
          return;
        }
        data.nodes[findIndex] = insertNode;
      } else {
        data.nodes.push(insertNode);
      }

      this.$set(this.nodesGroupMap, insertNode.id, groupId);

      console.log('==== 插入数据后 ======');
      console.log(data.nodes, this.nodesGroupMap);
      console.log('');

      this.nodes = data.nodes;

      this.graph.read(data);

      this.edgesToFront();
      this.resetCanvas();

      setTimeout(() => {
        this.isProcessing = false;
      }, 100);
    },

    /**
       * 线段到最前面
       */
    edgesToFront() {
      const edges = this.graph.getEdges();
      edges.forEach((edge) => {
        edge.toFront();
      });
    },

    /**
       * 添加节点
       */
    handleAddEvent(item) {
      this.insertEvent = item;
      // this.insertIndex = index;
      this.eventDialogVisible = true;
    },

    /**
       * 添加分组
       */
    handleAddGroup(index) {
      if (index >= 10) {
        this.$message.warning('最多只能创建10个组别！');
        return;
      }
      const nodes = cloneDeep(this.graph.save().nodes);
      // 获取上一个分组的数据
      const nodesGroups = this.createNodeGroups(nodes);

      if (!nodesGroups[index - 1] || !nodesGroups[index - 1]?.length) {
        Message.error('尚有没有使用的分组');
        return;
      }

      const color = this.lineColor[index]
        ? this.lineColor[index] : this.lineColor[index - this.lineColor.length];

      const data = cloneDeep(this.graph.save());
      const insertGroup = this.createGroup(
        { id: index, color },
        index,
      );

      data.nodes.push(insertGroup);

      this.groups.push({
        label: `第${index + 1}组`,
        id: index,
        color,
      });
      this.graph.read(data);
      this.nodes = data.nodes;

      this.resetCanvas();
      this.edgesToFront();
    },

    /**
       * 计算事件节点的x方向
       */
    calcEventNodeX(groupIndex = 0) {
      return (
        (this.groupWidth * (groupIndex + 1)) - (this.eventNodeWidth + (this.eventNodeWidth / 2))
      );
    },

    /**
       * 计算事件节点的y方向
       */
    calcEventNodeY(lastNode) {
      return lastNode?.y ? lastNode.y + 60 : 120;
    },

    /**
       * 创建节点
       */
    createNode(item, lastNode) {
      const { group: groupIndex } = item;
      return {
        type: 'event',
        id: item.eventCode,
        // eslint-disable-next-line max-len
        // x: ((this.groupWidth * (groupIndex + 1)) - (this.groupWidth / 2)) - (((item.label.length + 1) * 15) / 2),
        x: this.calcEventNodeX(groupIndex),
        y: this.calcEventNodeY(lastNode),
        label: item.eventName,
        codeLabel: item.eventCode,
        item,
        style: {
          fill: 'rgb(211, 223, 229)',
          stroke: '#888',
          lineWidth: 1,
          radius: 4,
          fontSize: 12,
        },
        group: groupIndex,
        size: 28,
        linkPoints: {
          top: false,
          bottom: false,
          left: false,
          right: true,
        },
      };
    },

    /**
       * 创建分组
       */
    createGroup({ id, color }, index) {
      return {
        id: `${id}`,
        type: 'rect',
        x: index * this.groupWidth + (this.groupLineWidth / 2),
        y: 0,
        label: '',
        draggable: false,
        labelStyle: {
          fontSize: 12,
        },
        style: {
          fill: color,
          lineWidth: 0,
        },
        size: [
          this.groupLineWidth,
          this.containerHeight * 2,
        ],
        color: '#333',
      };
    },

    /**
       * 事件删除
       */
    removeItem(ev, render = true) {
      const { group = '', id = '' } = ev.target.attrs;
      // 删除当前节点
      const item = this.graph.findById(id);

      if (item) {
        this.graph.removeItem(item);
      }

      delete this.nodesGroupMap[id];

      // 根据id事件池那里获取到对应的事件
      // const queryEvent = this.cacheEvents.find((eventItem) => eventItem.id === id);
      // this.events.push(queryEvent);

      // 根据当前的nodes
      const data = cloneDeep(this.graph.save());

      this.nodes = data.nodes;

      const nodesGroups = this.createNodeGroups(data.nodes);

      if (!nodesGroups[group]) {
        // eslint-disable-next-line max-len
        const queryGroupIndex = this.groups.findIndex((groupItem) => groupItem.id * 1 === group * 1);

        // eslint-disable-next-line no-unused-expressions
        queryGroupIndex > -1 ? this.groups.splice(queryGroupIndex, 1) : () => {};

        // 修改的记录
        const groupIdDiff = {};
        const groupsNodes = []; // 新的分组

        // 重置了所选择的组
        this.groups.forEach((groupItem, index) => {
          groupIdDiff[groupItem.id] = index;
          groupItem.id = index;
          groupItem.label = `第${index + 1}组`;
          groupsNodes.push(this.createGroup(groupItem, index));
        });

        if (this.groups.length === 0) {
          const color = this.lineColor[0];
          this.groups.push(
            {
              label: '第1组',
              id: 0,
              color,
            },
          );
          const insertGroup = this.createGroup(
            {
              id: 0,
              color,
            },
            0,
          );
          groupsNodes.push(insertGroup);
        }

        const nodes = data.nodes.filter((nodeItem) => nodeItem.label !== '' && nodeItem.y !== 0);

        nodes.forEach((nodeItem) => {
          const isChange = nodeItem.group !== groupIdDiff[nodeItem.group];

          nodeItem.group = groupIdDiff[nodeItem.group];
          // 需要根据情况来，计算实际是否需要重置
          const calcValue = nodeItem.x - this.groupWidth;
          if (calcValue > 0) {
            // eslint-disable-next-line no-param-reassign, no-unused-expressions
            isChange && (nodeItem.x = calcValue);
          }
        });

        data.nodes = [...groupsNodes, ...nodes];
        this.nodes = data.nodes;

        if (render) {
          this.graph.read(data);
          this.edgesToFront();
        } else {
          this.graph.data(data);
        }
        this.resetCanvas();
      }
    },

    /**
       * 重置容器宽度
       */
    resetCanvas() {
      // nodes groups
      let max = 0;
      const { length } = this.groups;
      if (this.nodes.length) {
        const nodesGoupsStr = this.nodes.map((item) => item.group).join(',');
        new Array(length).fill('').forEach((item, index) => {
          const matchLen = String(nodesGoupsStr).match(new RegExp(`${index}`, 'g'))?.length || 0;
          max = max > matchLen ? max : matchLen;
        });
      }
      const width = length * this.groupWidth;
      const height = max * this.groupHeight;

      // console.log(this.containerHeight, height, max);
      this.containerHeight = height < this.containerHeight ? this.containerHeight : height;
      this.containerWidth = width < this.containerMinWidth ? this.containerMinWidth : width;
      this.graph.changeSize(this.containerWidth, this.containerHeight);

      this.groups.forEach(({ id }) => {
        this.graph.updateItem(this.graph.findById(id), this.createGroup(
          {
            id,
            color: this.lineColor[id],
          },
          id,
        ));
      });
    },

    /**
       * 事件绑定
       */
    initEvent() {
      if (!this.graph) {
        return;
      }

      this.graph.on('canvas:click', () => {
        this.edgeAdding = false;
      });

      /**
         * 节点点解关闭按钮
         */
      this.graph.on('close:click', (ev) => this.removeItem(ev));

      /**
         * 节点拖拽
         */
      this.graph.on('node:dragend', (ev) => {
        if (!ev?.target?.attrs?.id) {
          return;
        }

        const toGroup = this.getPointToGroup({ x: ev.x, y: ev.y });
        const originalGroup = ev.target.attrs.group;

        // 判断原来的组和需要移动到的组是否相同，如果相同不做任何操作
        if ((toGroup * 1) - 1 === originalGroup * 1) {
          return;
        }

        // 判断需要被移动的节点是否只有一个元素，如果是的话，不允许移动
        const filterNodes = this.nodes.filter((node) => node.type === 'event' && node.group === originalGroup);

        if (filterNodes.length <= 1) {
          Message.error('只有一个节点的分组，不允许更换分组');
          return;
        }

        // 判断需要移动到的分组是否存在
        const findGroup = this.groups.find((group) => group.id * 1 === (toGroup * 1) - 1);

        if (!findGroup) {
          Message.error('移动的位置，分组不存在');
          return;
        }

        // this.removeItem({
        //   target: {
        //     attrs: {
        //       group: originalGroup,
        //       id: ev.target.attrs.id,
        //     },
        //   },
        // }, false);

        this.$nextTick(() => {
          const index = this.cacheEvents.findIndex((item) => item.eventCode === ev.target.attrs.id);
          this.insertEvent = this.cacheEvents[index];
          // this.insertIndex = index;
          this.handleAddEventConfirm(toGroup - 1, true);
        });
      });
    },

    /**
       * 初始化图表
       */
    init() {
      if (this.graph) {
        return;
      }

      // const that = this;

      // G6.registerBehavior('click-add-edge', clickAddEdge);
      G6.registerNode('event', EventNode, 'rect');

      this.graph = new G6.Graph({
        container: 'container',
        width: this.containerWidth,
        height: this.containerHeight,
        groupByTypes: false,
        modes: {
          // 'drag-node', // 内置行为
          // 'click-select', // 内置行为
          // 'click-add-edge',
          default: [
            // {
            //   type: 'create-edge',
            //   // trigger: 'drag',
            //   edgeConfig: {
            //     type: 'cubic',
            //   },
            //   shouldBegin(e) {
            //     const pass = !!e?.target?.attrs?.id;
            //     if (pass) {
            //       this.startX = e.canvasX;
            //       this.startGroup = e?.target?.attrs?.group || 0;
            //       that.edgeAdding = true;
            //     }
            //     return pass;
            //   },
            //   shouldEnd(e) {
            //     const pass = !!e?.target?.attrs?.id;
            //     if (pass) {
            //       const currentGroup = e?.target?.attrs?.group || 0;

            //       if (e.canvasX <= this.startX) {
            //         Message.error('请选择正确的节点链接');
            //         return false;
            //       }

            //       if (currentGroup === this.startGroup) {
            //         Message.error('请选择正确的节点链接');
            //         return false;
            //       }

            //       if (currentGroup - this.startGroup > 1) {
            //         Message.error('请选择正确的节点链接');
            //         return false;
            //       }
            //     }
            //     return pass;
            //   },
            // },

            {
              type: 'tooltip',
              formatText(model) {
                return `<p style="text-align: left">${model.label}<br />${model.codeLabel}</p>`;
              },
              offset: 30,
              shouldBegin: (e) => e.target.attrs.ellipsis,
            },

            {
              type: 'drag-node',
              enableDelegate: true,
              shouldBegin(e) {
                this.nodeInfo = {
                  id: e?.target?.attrs?.id,
                  label: e?.target?.attrs?.label,
                  group: e?.target?.attrs?.group,
                };
                this.dragCanvasStartX = e.canvasX;
                this.dragCanvasStartY = e.canvasY;
                return true;
              },
              shouldEnd() {
                return false;
              },
            },
          ],
          // default: ['drag-node', 'click-select', 'click-add-node', '', 'keyboard'],
        },
        // defaultEdge: {
        //   style: {
        //     lineWidth: 2, // 线宽
        //     stroke: '#778899', // 线的颜色
        //     endArrow: { // 设置终点箭头
        //       path: G6.Arrow.vee(5, 5, 0), // 使用内置箭头路径函数，参数为箭头的 宽度、长度、偏移量（默认为 0，与 d 对应）
        //       d: 0,
        //     },
        //   },
        // },
      });

      const data = {
        nodes: [],
      };

      const groupsNodes = [];

      // 根据节点渲染内容
      this.nodes.forEach((item) => {
        const { group: groupIndex } = item;

        if (!groupsNodes[groupIndex]) {
          groupsNodes[groupIndex] = [];
        }

        const currentGroup = groupsNodes[groupIndex];
        const lastNode = currentGroup[currentGroup.length - 1];

        let currentNode = {};

        if (!lastNode) {
          // 判断属于哪个分组
          currentNode = this.createNode(item, null);
          currentGroup.push(currentNode);
        } else {
          currentNode = this.createNode(item, lastNode);
          currentGroup.push(currentNode);
        }

        data.nodes.push(currentNode);
      });

      // 根据具有的组合绘画分组的边框
      this.groups.forEach((item, index) => {
        data.nodes.push(this.createGroup(item, index));
      });

      this.nodes = data.nodes;

      console.log(this.nodes);

      this.graph.read(data);
    },

    /**
       * 根据html5的拖拽事件获取的坐标，转换为拖拽到的所在组
       */
    getPointToGroup(point) {
      const { x, y } = point;
      if (y < 0) {
        return null;
      }
      return Math.ceil(x / this.groupWidth);
    },

    handleDragstart(insertEvent) {
      this.dargEvent = insertEvent.id;
    },

    /**
       * 处理h5拖拽结束的事件
       */
    handleDragend(ev, insertEvent) {
      if (this.dargEvent !== insertEvent.id) {
        return;
      }

      const point = this.graph.getPointByClient((ev.x), ev.y);
      const groupId = this.getPointToGroup(point);

      // 判断当前需要移动到的分组是否存在
      if (groupId > this.groups.length) {
        return;
      }

      if (groupId) {
        this.insertEvent = insertEvent;
        // this.insertIndex = insertIndex;

        this.handleAddEventConfirm(groupId - 1);
        this.dargEvent = null;
      }
    },
  },
  beforeDestroy() {
    this.graph = null;
    this.isProcessing = false;
  },
  mounted() {
    this.containerWidth = this.$refs.container.offsetWidth;
    this.containerMinWidth = this.$refs.container.offsetWidth;
    const {
      // groups,
      lineColor,
    } = this;
    if (this.$route.query.id) {
      const {
        id, traceName, traceDesc, traceType,
      } = this.$route.query;
      this.formQuery.id = id;
      this.formQuery.traceName = traceName;
      this.formQuery.traceDesc = traceDesc;
      this.formQuery.traceType = traceType;

      const traceConfigs = JSON.parse(window.localStorage.getItem('traceConfigs') || '{}');

      let maxGroup = 0;
      traceConfigs.forEach((item) => {
        item.id = item.eventCode;
        item.group = item.groupSeq;
        maxGroup = Math.max(maxGroup, +item.group);

        this.cacheEvents.push(item);
        this.$set(this.nodesGroupMap, item.id, item.group);
      });
      new Array(maxGroup + 1).fill('').forEach((item, index) => {
        this.groups.push({
          label: `第${index + 1}组`,
          id: index,
          color: lineColor[index],
        });
      });
      this.nodes.splice(0);
      this.nodes.push(...traceConfigs);
    } else {
      this.groups.push({
        label: '第1组',
        id: 0,
        color: lineColor[0],
      });
    }

    this.init();
    this.initEvent();
    this.resetCanvas();

    const today = Moment().format('YYYY-MM-DD');
    const today2 = Moment().subtract(7, 'days').format('YYYY-MM-DD');
    this.formQuery.range = [new Date(today2), new Date(today)];
    this.queryPageInfo();
  },
};
</script>
  <style lang="scss">
  .g6-tooltip {
    padding: 10px 6px;
    color: #444;
    background-color: rgba(255, 255, 255, 0.9);
    border: 1px solid #e2e2e2;
    border-radius: 4px;
    font-size: 12px;
    min-width: 100px;
    z-index: 2;
  }
  </style>
  <style lang="scss" scoped>
  .app-layout {
    min-width: 800px;
    margin: 15px 15px 0;
  }

  .box-card {
    padding: 20px;
  }

  .form {
    text-align: left;
  }

  .events {
    display: flex;
    min-height: 32px;
    align-items: center;
    flex-flow: wrap
  }
  .event-list {
    max-height: 200px;
    overflow: auto;
  }
  .event {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    min-height: 28px;
    line-height: 22px;
    font-size: 12px;
    margin-right: 10px;
    padding: 4px 20px;
    border-radius: 3px;
    cursor: move;
    overflow: hidden;
    &.info {
      background: rgb(211, 223, 229);
    }
    &.success {
      background: #409EFF;
      color: #fff;
    }
    .event-icon {
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 6px;
      border-bottom-right-radius: 10px;
      background: rgba(255, 255, 255, .95);
      color: #409EFF;
    }
  }

  .container {
    position: relative;
    padding: 0;
    max-width: 100%;
    // max-height: 500px;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .container-title {
    display: flex;
    font-size: 12px;
    color: rgb(184, 184, 184);
    position: relative;
  }

  .container-title-item {
    text-align: left;
    min-width: 240px;
    max-width: 240px;
    position: relative;
  }

  .item-hover {
    position: absolute;
    width: 5px;
    height: 520px;
    z-index: 1;
    top: 0;
    opacity: 0;
  }

  .item-hover-icon {
    font-size: 13px;
    position: relative;
    top: 2;
    left: -3px;
    color: rgb(70, 114, 244);
  }

  .item-hover-bar {
    background: rgb(70, 114, 244);
    display: block;
    width: 5px;
    height: 520px;
  }

  .item-hover-container {
    position: relative;
  }

  #container {
    background: rgb(245, 245, 245);
    overflow: hidden;
  }
  </style>
